// On native Android, localhost doesn't exist — must use the actual server.
// On web (deployed), empty string uses relative URLs (Nginx proxies /api/*).
// For local dev, set REACT_APP_API_URL=http://localhost:4000 in .env
const _isNative = typeof window !== 'undefined' && window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform();
export const API_URL = _isNative
  ? "https://settup.ai"
  : (process.env.REACT_APP_API_URL || "");

const headers = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const api = {
  signup: (email, password) =>
    fetch(`${API_URL}/auth/signup`, { method: "POST", headers: headers(), body: JSON.stringify({ email, password }) }).then(r => r.json()),

  login: (email, password) =>
    fetch(`${API_URL}/auth/login`, { method: "POST", headers: headers(), body: JSON.stringify({ email, password }) }).then(r => r.json()),

  saveAnswers: (token, answers, stage) =>
    fetch(`${API_URL}/interview/answers`, { method: "POST", headers: headers(token), body: JSON.stringify({ answers, stage }) }).then(r => r.json()),

  getMatches: (token) =>
    fetch(`${API_URL}/matches`, { headers: headers(token) }).then(r => r.json()),

  matchAction: (token, matchId, action) =>
    fetch(`${API_URL}/matches/${matchId}/action`, { method: "POST", headers: headers(token), body: JSON.stringify({ action }) }).then(r => r.json()),

  getMessages: (token, matchId) =>
    fetch(`${API_URL}/messages/${matchId}`, { headers: headers(token) }).then(r => r.json()),

  sendMessage: (token, matchId, content) =>
    fetch(`${API_URL}/messages/${matchId}`, { method: "POST", headers: headers(token), body: JSON.stringify({ content }) }).then(r => r.json()),

  getProfile: (token) =>
    fetch(`${API_URL}/profile`, { headers: headers(token) }).then(r => r.json()),
};

export const auth = {
  getToken: () => localStorage.getItem("soul_token"),
  setToken: (token) => localStorage.setItem("soul_token", token),
  clearToken: () => localStorage.removeItem("soul_token"),
  getUser: () => { try { return JSON.parse(localStorage.getItem("soul_user") || "null"); } catch { return null; } },
  setUser: (user) => localStorage.setItem("soul_user", JSON.stringify(user)),
  clearUser: () => localStorage.removeItem("soul_user"),
  isLoggedIn: () => !!localStorage.getItem("soul_token"),
};
